import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.background.paper,
}

export const contentGridSx: SxProps<Theme> = {
  maxWidth: {
    xs: '100%',
    lg: '111.2rem',
    xl: '151.6rem',
  },
  margin: 'auto',
  columnGap: {
    lg: '4.8rem',
  },
  alignItems: 'center',
  padding: {
    xs: '2.4rem',
    md: '2.4rem 5.6rem',
    lg: 0,
  },
}

export const affordableFlatRateSubscriptionForEffectiveLeadGenerationLeftSideWrapperSx: SxProps<Theme> =
  {
    display: 'flex',
    alignItems: 'center',
    height: {
      xs: 'auto',
      lg: '60.8rem',
      xl: '58rem',
    },
    padding: {
      xs: '0 0 2.4rem',
      md: '2.4rem 0',
      lg: 0,
    },
    order: {
      xs: 1,
      lg: 'initial',
    },
  }

export const affordableFlatRateSubscriptionForEffectiveLeadGenerationLeftSideContentSx: SxProps<Theme> =
  {
    gap: {
      xs: '1.6rem',
      md: '2.4rem',
    },
  }

export const affordableFlatRateSubscriptionForEffectiveLeadGenerationRightSideWrapperSx: SxProps<Theme> =
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    order: {
      xs: 2,
      lg: 'initial',
    },
    padding: {
      xs: '1rem 0 3.2rem',
      md: '0 0 2.4rem',
      lg: 0,
    },
    borderBottom: {
      xs: '0.1rem solid rgba(0, 0, 0, 0.12)',
      lg: 0,
    },
  }

export const affordableFlatRateSubscriptionForEffectiveLeadGenerationRightSideImageSx: SxProps<Theme> =
  {
    width: {
      xs: '100%',
      lg: '53.2rem',
      xl: '72.2rem',
    },
    maxWidth: {
      md: '72.2rem',
    },
  }

export const stayAheadOfTheCurveWithContinuousInnovationLeftSideWrapperSx: SxProps<Theme> =
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: {
      xs: 'auto',
      lg: '54rem',
      xl: '56.8rem',
    },
    order: {
      xs: 4,
      lg: 'initial',
    },
    paddingBottom: {
      xs: '1.6rem',
      md: '3.4rem',
      lg: 0,
    },
  }

export const stayAheadOfTheCurveWithContinuousInnovationLeftSideImageSx: SxProps<Theme> =
  {
    width: {
      xs: '100%',
      lg: '53.2rem',
      xl: '73.1rem',
    },
    maxWidth: {
      md: '72.2rem',
      lg: '100%',
    },
  }

export const stayAheadOfTheCurveWithContinuousInnovationRightSideWrapperSx: SxProps<Theme> =
  {
    display: 'flex',
    alignItems: 'center',
    order: {
      xs: 3,
      lg: 'initial',
    },
    padding: {
      xs: '2.4rem 0 3.8rem',
      md: '2.4rem 0 3.4rem',
      lg: 0,
    },
  }

export const stayAheadOfTheCurveWithContinuousInnovationRightSideContentSx: SxProps<Theme> =
  {
    gap: {
      xs: '1.6rem',
      md: '2.4rem',
    },
  }

export const dividerWrapperSx: SxProps<Theme> = { padding: '0 !important' }

export const titleSx: SxProps<Theme> = {
  color: (theme) => theme.palette.primary.main,
}

export const stayAheadOfTheCurveWithContinuousInnovationBulletPointsSx: SxProps<Theme> =
  {
    width: {
      md: '101%',
      lg: '100%',
    },
  }
